<template>
  <div class="telilcjis flex">
    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">1</span></div>
      <div class="lcjsmxwz">选择律师</div>
    </div>

    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">2</span></div>
      <div class="lcjsmxwz">提交订单</div>
    </div>

    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">3</span></div>
      <div class="lcjsmxwz">支付费用</div>
    </div>

    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">4</span></div>
      <div class="lcjsmxwz">平台接通律师完成通话</div>
    </div>

    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">5</span></div>
      <div class="lcjsmxwz">通话完成</div>
    </div>

    <div class="lcjisitem">
      <div class="lcjissort"><span class="sp">6</span></div>
      <div class="lcjsmxwz">评价律师</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.telilcjis {
  width: 1200px;
  margin: 0 auto;
  padding: 0 55px;
  .lcjisitem {
    flex: 1;
    position: relative;
    text-align: center;
    .lcjissort {
      text-align: center;
      line-height: 30px;
      .sp {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin: 0 auto;
        background: #ffffff;
        border: 1px solid #ddd;
        border-radius: 50%;
        font-size: 20px;
        color: #ddd;
        position: relative;
        z-index: 2;
      }
      &::before {
        content: "";
        position: absolute;
        top: 15px;
        left: 90px;
        width: 100%;
        height: 2px;
        background-color: #ddd;
        z-index: 1;
      }

      &::after {
        content: ">>>";
        position: absolute;
        top: 2px;
        left: 144px;
        width: 70px;
        color: #ddd;
        background-color: #f8f8f8;
        height: 26px;
        z-index: 3;
        line-height: 26px;
        font-size: 22px;
      }
    }
    .lcjsmxwz {
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
    }
    &:last-child {
      .lcjissort::before,
      .lcjissort::after {
        display: none;
      }
    }
  }
}
</style>